/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:26:04
 */
export default {
  lang: "英语",
  landing: {
    name1: "Abrir o Carlcare",
    name2: "Faça uma reserva",
    name3: "Com o Carlcare, pode verificar o seu pedido em qualquer momento.",
    name4: "",
    name5: "Deslize para a direita",
    name6: "Verificação concluída",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "Escolha o modelo do dispositivo",
    name2: "Descrição da falha:",
    name3: "Toque para seleccionar a loja de assistência",
    name4: "Loja da assistência:",
    name5: "Tempo de reserva:",
    name6: "Descreva detalhadamente o problema do seu dispositivo!",
    name7: "Toque para seleccionar a hora de chegada",
    name8: "Insira os detalhes correctos do seu contacto de modo a podermos contactá-lo",
    name9: "A hora de reserva disponível é como se indica",
    name10: "Mangyaring ipasok ang numero ng iyong telepono",
    name11: "Preço",
    name12: "Informações pessoais:",
    name13: "Por favor, insira seu nome",
    name14: "Submeter",
    name15: "Cancelar",
    name16: "OK",
  },
  shops: {
    name1: "Baseado na marca que escolheu, pode ser atendido nas seguintes lojas!",
    name2: "Brevemente em mais lojas! Fique connosco!",
  },
  price: {
    name1: "Marca",
    name2: "Modelo",
    name3: "ITEM",
    name4: "Preço",
    name5: "Lembrete amigável:",
    name6: "Estes preços são apenas para referência e o preço actual está sujeito ao estado do seu dispositivo.",
    name7: "Se não existir qualquer símbolo especial, a unidade do preço é a unidade de moeda local.",
    name8: "Lamentamos! Não existe informação de preço disponível na região actual.",
    name11:"Custo de Mão de Obra",
    name12:"Preço Total",
    name13: "5. Se o custo da mão de obra for \"/\", significa que o custo da mão de obra precisa de ser consultado com a loja.",
    item_main_board: "Placa principal",
    item_screen_frame: "Ecrã (Moldura)",
    item_screen_screen_frame: "Ecrã Secundário (Moldura)",
    item_touch_screen: "Ecrã tátil",
    item_camera: "\"Câmara\"",
    item_fixed_focus_camera: "Câmera de Foco Fixo",
    item_auto_focus_camera: "Câmera de Foco Automático",
    item_screen: "Ecrã",
    item_secondary_screen: "Tela Secundária",
    item_fingerprint_module: "Módulo de Impressão Digital",
    item_speaker: "Altifalante",
    item_receiver: "Receptor",
    item_small_board: "Pequena Placa",
    item_battery_cover: "Tampa da Bateria",
    item_battery: "Bateria",
    item_charger: "Carregador",
    item_usb_cable: "Cabo USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Sem dados",
    name2: "Fornecedor de serviço:",
    name3: "Marca do serviço:",
    name4: "Telefone:",
    name5: "Quantidade da encomenda:",
    name6: "Classificação da assistência",
    name7: "Ambiente da assistência:",
    name8: "Atitude da assistência:",
    name9: "Eficiência da assistência:",
    name10: "Qualidade da assistência:",
    name11: "Avaliação do cliente",
    name12:"para",
    name13:"Fechado",
    name14:"Address:",
  },
  reserSuccess: {
    // name1:
    //   "Abrir o Carlcare",
    name1: "Faça a captura de ecrã da informação da reserva e guarde-o como um recibo para aceder ao serviço prioritário.",
    name2: "Submetido com sucesso",
    name3: "1. Limpar dados",
    name4: "Faça antecipadamente cópia de segurança dos dados privados no seu telefone",
    name5: "2. Desactivar a palavra-passe de activação",
    name6: "Antes de se dirigir à loja, deve:",
    name7: "Loja da assistência:",
    name8: "Tempo de reserva:",
    name9: "Descrição da falha:",
    name10: "Modelo do dispositivo:",
    name11: "Número do pedido：",
    name12: "Informação da encomenda",
  },
  title: {
    
    name1: "Suporta os seguintes países:",
    name2: "Escolha o modelo",
    name3: "Reserva",
    name4: "Detalhes da loja de assistência",
    name5: "Seleccionar a loja de assistência",
  },
  error: {
    
    name1: "Sem dados. Deve verificar a sua informação da reparação",
    name2: "Necessita de mais ajuda? Por favor, contacte-nos.",
    name3: "Lamentamos, não existe um centro Carlcare na região actual.",
    name4: "Escolha primeiro um centro de serviço",
    name5: "Falha",
    name6: "Escolha primeiro o modelo do dispositivo",
    name7: "Detalhes",
    name8: "Descreva detalhadamente as suas necessidades",
    name9: "",
  },
  add1:{
    "name0": "pt-rPT",
    "name1": "Sua encomenda foi confirmada. Estamos ansiosos para sua chegada.",
    "name2": "Selecioná-lo da cidade",
    "name3": "Por favor introduza um número de telemóvel com %1$s dígitos.",
    "name4": "Horários do Dia Útil",
    "name5": "Segunda-feira",
    "name6": "Terça-feira",
    "name7": "Quarta-feira",
    "name8": "Quinta-feira",
    "name9": "Sexta-feira",
    "name10": "Sábado",
    "name11": "Domingo",
    "name12": "Introduzir país e pesquisar"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Outros",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Toque para Redirecionar",
    name3:"Abra a aplicação Carlcare para avaliar a encomenda",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Seleccionar Serviço",
    name7:"Limpeza Gratuita",
    name8:"Atualização de software",
  },
  cancelorder:{
    "cancelReason0": "Informação incorrecta",
    "cancelReason1": "Não pode chegar a tempo",
    "cancelReason2": "Pedido duplicado/Não é o meu pedido",
    "cancelReason3": "A falha não é repetida",
    "cancelReason4": "Apenas para teste/inquérito/evento/…",
    "cancelReason5": "Preço alto",
    "cancelReason6": "Falta de material",
    "cancelReason7": "Sem serviços diferenciados",
    "cancelReason8": "A loja é muito longe",
    "cancelReason9": "A loja está fechada",
    "cancelReason10": "Má atitude de serviço",
    "cancelReason11": "Substituição/reparação para outras marcas",
    "cancelReason12": "Não é possível encontrar a loja",
    "cancelReason13": "Outros",
    "cancelOrder": "Cancelar a encomenda",
    "reason_dialog_title": "Diga-nos a razão de cancelamento",
    "Cancel": "Cancelar",
    "OK": "OK",
    "name1": "Digite o código de verificação",
    "name2": "Código de verificação inválido",
    "repair_reservation_detail_canceled": "Esta encomenda foi cancelada!",
    "purchase_cancel_dialog_content": "Confirma o cancelamento da encomenda?",
    "yes": "\"Sim\"",
    "no": "Não"
}
};
